import React from 'react';
import { FadeIn } from './FadeIn';
import { Moon, Thermometer, BatteryWarning } from 'lucide-react';
export function PainSection() {
  return <section className="py-10 sm:py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-156">
      <div className="max-w-3xl mx-auto" data-id="element-157">
        <FadeIn data-id="element-158">
          <div className="text-center mb-6 sm:mb-12" data-id="element-159">
            <h2 className="text-2xl sm:text-4xl font-bold text-charcoal mb-3 sm:mb-6" data-id="element-160">
              ¿Te despiertas a las 3 de la mañana empapada en sudor?
            </h2>
            <p className="text-base sm:text-xl text-charcoal-light leading-relaxed font-serif italic" data-id="element-161">
              Con el corazón latiendo a mil por hora, preguntándote en qué
              momento tu cuerpo dejó de ser "tuyo"...
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-162">
          <div className="prose prose-sm sm:prose-lg text-charcoal-light mx-auto" data-id="element-163">
            <p className="mb-4 sm:mb-6 text-sm sm:text-base" data-id="element-164">
              No es falta de voluntad, no es "el paso del tiempo"... es un{' '}
              <strong data-id="element-165">desequilibrio químico</strong> que ninguna dieta
              convencional va a solucionar. Si sientes que engordas con solo
              mirar un vaso de agua y que tu paciencia se agota en segundos,
              este mensaje es exactamente lo que necesitabas leer hoy.
            </p>

            <div className="bg-cream p-5 sm:p-8 rounded-2xl my-6 sm:my-10 border border-sage/20 relative" data-id="element-166">
              <div className="absolute -top-4 -left-4 text-sage opacity-20 hidden sm:block" data-id="element-167">
                <svg width="80" height="80" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-168">
                  <path d="M14.017 21L16.411 14.182L21.5 14.182L17.383 9.818L18.96 3L14.017 6.818L9.074 3L10.651 9.818L6.534 14.182L11.623 14.182L14.017 21Z" data-id="element-169" />
                </svg>
              </div>
              <p className="relative z-10 text-sm sm:text-lg" data-id="element-170">
                Es frustrante, lo sé. Compras la ropa una talla más grande "por
                si acaso". Evitas las reuniones sociales porque no sabes si un
                sofoco te dejará en evidencia o si un cambio de humor te hará
                decir algo de lo que te arrepientas. Te han dicho que "es parte
                de la edad", que "tienes que aguantar". Pero mientras tú sufres
                en silencio, tu metabolismo se inflama más y cada noche de
                insomnio envejece tus células el doble de rápido.
              </p>
            </div>

            <div className="grid grid-cols-3 gap-3 sm:gap-6 mb-6 sm:mb-10" data-id="element-171">
              <div className="bg-white p-3 sm:p-6 rounded-xl shadow-sm border border-cream-dark text-center" data-id="element-172">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-sage/10 rounded-full flex items-center justify-center mx-auto mb-2 sm:mb-4 text-sage-dark" data-id="element-173">
                  <Thermometer className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-174" />
                </div>
                <h3 className="font-bold text-charcoal text-xs sm:text-base mb-0" data-id="element-175">
                  Sofocos
                </h3>
              </div>
              <div className="bg-white p-3 sm:p-6 rounded-xl shadow-sm border border-cream-dark text-center" data-id="element-176">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-sage/10 rounded-full flex items-center justify-center mx-auto mb-2 sm:mb-4 text-sage-dark" data-id="element-177">
                  <Moon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-178" />
                </div>
                <h3 className="font-bold text-charcoal text-xs sm:text-base mb-0" data-id="element-179">
                  Insomnio
                </h3>
              </div>
              <div className="bg-white p-3 sm:p-6 rounded-xl shadow-sm border border-cream-dark text-center" data-id="element-180">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-sage/10 rounded-full flex items-center justify-center mx-auto mb-2 sm:mb-4 text-sage-dark" data-id="element-181">
                  <BatteryWarning className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-182" />
                </div>
                <h3 className="font-bold text-charcoal text-xs sm:text-base mb-0" data-id="element-183">
                  Fatiga
                </h3>
              </div>
            </div>

            <p className="text-base sm:text-xl font-medium text-charcoal border-l-4 border-sage pl-4 sm:pl-6 py-2" data-id="element-184">
              El verdadero problema no es la menopausia. El problema es que
              estás usando reglas de nutrición de los años 90 para un cuerpo que
              hoy necesita una gestión hormonal de precisión.
            </p>
            <p className="mt-4 sm:mt-6 text-sm sm:text-base" data-id="element-185">
              Seguir haciendo lo mismo y esperar un resultado diferente solo te
              llevará a más fatiga, más peso abdominal y más frustración.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}